import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.scss'

const Button = (props) => {
    const {
        primary,
        secondary,
        children,
        inline,
        block,
        right,
        left,
        className,
        ...rest
    } = props

    rest.className = styles(styles.btn, className, {
        primary,
        secondary,
        inline,
        block,
        right,
        left,
    })
    return (
        <a {...rest}>
            {children}
        </a>
    )
}

Button.propTypes = {
    primary: PropTypes.bool,
    secondary: PropTypes.bool,
    children: PropTypes.node,
    inline: PropTypes.bool,
    block: PropTypes.bool,
    right: PropTypes.bool,
    left: PropTypes.bool,
    className: PropTypes.string,
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/index.js